import {
    ModelSetTransformer,
    ModelTransformer,
} from '../../../../common/common.model';

export interface ExtSiteItem {
    tenantId: number;
    siteId: number;
    siteDefaultInitials: string;
    siteDefaultShortName: string;
    siteDefaultName: string;
    clientTranslationTextId: number;
    /** source from mssql sys.time_zone_info */
    timeZone: string;
    isThirdParty: boolean;
    enabled: boolean;
    createdByUserId: number;
    createdOn: string;
    lastUpdatedByUserId: string;
    lastUpdatedOn: string;
    userSite: any[];
    languageID: number;
}

export interface SiteItem {
    id: number;
    initials: string;
    shortName: string;
    name: string;
    isThirdParty: boolean;
}

class SiteItemModelTransformer
    implements ModelTransformer<SiteItem, ExtSiteItem>
{
    transform(model: ExtSiteItem): SiteItem {
        return {
            id: model.siteId,
            initials: model.siteDefaultInitials,
            shortName: model.siteDefaultShortName,
            name: model.siteDefaultName,
            isThirdParty: model.isThirdParty,
        };
    }
}

export class SiteItemModelSetTransformer extends ModelSetTransformer<
    SiteItem,
    ExtSiteItem
> {
    protected newTransformer(): ModelTransformer<SiteItem, ExtSiteItem> {
        return new SiteItemModelTransformer();
    }
}
